import {
  Form,
  Button,
  Space,
  Input,
  DatePicker,
  message,
  Select,
  Upload,
} from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

import { saveOrUpdate, test } from '@/api/recall';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useMemo, useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import { PublishStatusEnum, UserEnum, JumpTypeEnum, JumpTypeMap } from './type';
import { useRequest } from 'ahooks';
import { getPushMessageRecordDetail, postPushMessageRecordSaveOrUpdate, postPushMessageRecordTest } from '@/api/noticeConfig';
import { PushMessageReq } from '@/types/noticeConfig';
import UploadImage from '@/components/UploadImage';

const userArr = Object.keys(UserEnum).filter((item) => isNaN(Number(item)));

const PushDetail = () => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [form] = Form.useForm();

  const navigator = useNavigate();

  const { id } = useParams();
  const { data, run } = useRequest(
    (id) => getPushMessageRecordDetail({ id }),
    {
      manual: true,
    }
  );

  useEffect(() => {
    if (!data) return;
    const values = data.data.data
    form.setFieldsValue({
      ...values,
      pushTime: dayjs(values.pushTime)
    });
  }, [data]);

  useEffect(() => {
    if (!id) return;
    run(id);
  }, [id]);

  async function onSubmit() {
    const values: PushMessageReq = await form.validateFields();
    const formattedTime = dayjs(values.pushTime).format(
      'YYYY-MM-DD HH:mm:ss'
    );
    const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      const value = values[key as keyof PushMessageReq];
      // 选填字段为 undefined/null 时跳过, 避免 formData.append 写入字面量 "undefined" 字符串
      if (key !== "pushTime" && value !== undefined && value !== null) {
        formData.append(key, value as string | Blob);
      }
    })
    // formData.append('title', values.title);
    // formData.append('content', values.content);
    formData.append('pushTime', formattedTime);
    // formData.append('pushTargetType', values.pushTargetType.toString());
    formData.append('pushStatus', PublishStatusEnum.WAIT);
    if (id) {
      formData.append('id', id);
    }
    if (values.pushTargetType === 6) {
      if (!uploadedFile) {
        return message.error('请先上传Excel文件');
      }
      formData.append('file', uploadedFile);
    }
    try {
      const res = await postPushMessageRecordSaveOrUpdate(formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      // const res = await axiosInstance.post(
      //   `${baseUrl}/recallEmail/saveOrUpdate`,
      //   formData,
      //   {
      //     headers: {
      //       'Content-Type': 'multipart/form-data',
      //     },
      //   }
      // );
      if (res.data.status !== 200) {
        return message.error(res.data.message || '上传失败');
      }
      message.success(res.data.message || '上传成功');
      onCancel();
    } catch (err) {
      message.error('上传出错');
    }
  }

  async function onSubmitTest() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const values: PushMessageReq = await form.validateFields();
    const params: PushMessageReq = {
      ...values,
      pushTime: dayjs(values.pushTime).format('YYYY-MM-DD HH:mm:ss'),
    };

    const res = await postPushMessageRecordTest(params);
    if (res.status !== 200 || res.data.status !== 200) {
      return message.error(res.data.message);
    }

    message.success(res.data.message);
  }

  function onCancel() {
    navigator(-1);
  }

  const testUserId = Form.useWatch('testUserId', form) as string;

  // 监听 cover 变化, 自动按图片自然宽高算 ratio = width/height (保留 3 位小数对齐 DB DECIMAL(5,3))
  // 上传/回显/清除三种场景统一处理
  const cover = Form.useWatch('cover', form) as string | undefined;
  useEffect(() => {
    if (!cover) {
      form.setFieldValue('ratio', undefined);
      return;
    }
    const img = new window.Image();
    img.onload = () => {
      if (img.width > 0 && img.height > 0) {
        form.setFieldValue('ratio', Number((img.width / img.height).toFixed(3)));
      }
    };
    img.src = cover;
  }, [cover, form]);

  return (
    <div>
      <Form
        form={form}
        initialValues={{
          pushResource: 3,
        }}
      >
        <Form.Item label="推送对象userId" required>
          <Input.Group compact>
            <Upload
              name="file"
              accept=".xlsx,.xls"
              showUploadList={false}
              beforeUpload={(file) => {
                setUploadedFile(file); // 存文件
                form.setFieldsValue({ pushTargetType: 6 }); // 自动设为 Excel 类型
                return false;
              }}
            >
              <Button
                type="default"
                style={{
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  backgroundColor: '#f0f0f0',
                  borderRight: 'none',
                }}
              >
                excel表单上传
              </Button>
            </Upload>

            <Form.Item
              name="pushTargetType"
              noStyle
              rules={[{ required: true, message: '请选择推送对象' }]}
            >
              <Select
                style={{ width: 'calc(100% - 130px)' }}
                placeholder="请选择推送对象"
                value={form.getFieldValue('pushTargetType')}
              >
                {userArr.map((item) => {
                  const value = UserEnum[item] as string;
                  return (
                    <Select.Option value={value} key={value}>
                      {item}
                    </Select.Option>
                  );
                })}
                {uploadedFile && (
                  <Select.Option value={6} key="excel-upload">
                    {uploadedFile.name}
                  </Select.Option>
                )}
              </Select>
            </Form.Item>
          </Input.Group>
        </Form.Item>
        <Form.Item label="标题（英）" name="pushTitle" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="正文（英）" name="pushContent" rules={[{ required: true }]}>
          <Input.TextArea autoSize={{ minRows: 3, maxRows: 10 }} />
        </Form.Item>
        <Form.Item label="标题（日）" name="pushTitleJa" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="正文（日）" name="pushContentJa" rules={[{ required: true }]}>
          <Input.TextArea autoSize={{ minRows: 3, maxRows: 10 }} />
        </Form.Item>
        <Form.Item
          name="pushTime"
          label="发布时间（日本时间）"
          rules={[
            { required: true, message: '请选择发布时间' },
            {
              validator: (_, value: string) => {
                if (dayjs(value).isBefore(dayjs())) {
                  return Promise.reject(new Error('发布时间不能早于当前时间'));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <DatePicker
            showTime
            placeholder="请选择发布时间(日本时间)"
            style={{ width: '100%' }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Form.Item 
          label="跳转链接" 
          name="jumpType" 
          initialValue={JumpTypeEnum.NO_JUMP}
          normalize={(value) => value === undefined || value === null ? JumpTypeEnum.NO_JUMP : value}
          getValueProps={(value) => ({
            value: value === JumpTypeEnum.NO_JUMP ? undefined : value
          })}
        >
          <Select
            placeholder="请选择跳转链接"
            allowClear
            onChange={(value) => {
              form.setFieldValue('jumpType', value === undefined || value === null ? JumpTypeEnum.NO_JUMP : value);
              // 切换跳转类型时清空对应的 ID 输入, 避免脏数据被提交
              if (value !== JumpTypeEnum.ARTWORK_DETAIL) {
                form.setFieldValue('artworkId', undefined);
              }
              if (value !== JumpTypeEnum.CHALLENGE_DETAIL) {
                form.setFieldValue('bizId', undefined);
              }
            }}
          >
            {Array.from(JumpTypeMap.entries())
              .filter(([value]) => value !== JumpTypeEnum.NO_JUMP)
              .map(([value, label]) => (
                <Select.Option key={value} value={value}>
                  {label}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) => prev.jumpType !== curr.jumpType}
        >
          {({ getFieldValue }) =>
            getFieldValue('jumpType') === JumpTypeEnum.ARTWORK_DETAIL ? (
              <Form.Item
                label="作品ID"
                name="artworkId"
                rules={[
                  { required: true, message: '请输入作品ID' },
                  { pattern: /^\d+$/, message: '作品ID必须是数字' },
                ]}
              >
                <Input placeholder="请输入要跳转的作品ID" />
              </Form.Item>
            ) : null
          }
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) => prev.jumpType !== curr.jumpType}
        >
          {({ getFieldValue }) =>
            getFieldValue('jumpType') === JumpTypeEnum.CHALLENGE_DETAIL ? (
              <Form.Item
                label="挑战赛ID"
                name="bizId"
                rules={[
                  { required: true, message: '请输入挑战赛ID' },
                  { pattern: /^\d+$/, message: '挑战赛ID必须是数字' },
                ]}
              >
                <Input placeholder="请输入要跳转的挑战赛ID (contestId)" />
              </Form.Item>
            ) : null
          }
        </Form.Item>
        <Form.Item
          label="封面图"
          name="cover"
          extra="选填，建议 3:4 竖图（600×800）"
        >
          <UploadImage
            width={300}
            height={400}
            maxSize={5}
            showSizeHint
            showResolution
            acceptWebp
          />
        </Form.Item>
        <Form.Item name="ratio" hidden>
          <Input />
        </Form.Item>
        <Form.Item label="测试账号suppid" name="testUserId">
          <div style={{ display: 'flex', gap: 10 }}>
            <Input maxLength={50} placeholder='请填写Supp ID' />
            <Button
              type="primary"
              disabled={!testUserId || !testUserId.length}
              onClick={onSubmitTest}
            >
              推送到测试账号
            </Button>
          </div>
        </Form.Item>
        <Form.Item>
          <Space style={{ width: '100%', justifyContent: 'center' }}>
            <Button type="primary" onClick={onSubmit}>
              提交
            </Button>
            <Button onClick={onCancel}>取消</Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

export default PushDetail;
